export const SHARED_FOLDER_ID = 'shared';
